/**
 * Each module has a container with an unique id
 * To select properly everything, each jquery selection must start with: $(moduleId + " div.example")
 * Module name: map
 * Module id: map-module
 */

 

 /**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2016, Codrops
 * http://www.codrops.com
 */


var smartbugsStatus = false;
var patientLastInterval = undefined;
var smartbugLastInterval = undefined;
var smartbugs = [];
var groupPositions = [];
var patientPositions = [];
var animatePatients = [];


function clearAllInterval() {
    clearInterval(patientLastInterval);
    clearInterval(smartbugLastInterval);
    $(".pin").remove();
    smartbugsStatus = false;
    patientLastInterval = undefined
    smartbugs = [];
    groupPositions = [];
    patientPositions = [];
    animatePatients = [];

}

function showSmartbugs(showSmartbug=true) {
    if(showSmartbug){
        $("*[class*='smartbug-']").each(function(index){
            $(this).css('display', 'block');
        })
    } else {
        $("*[class*='smartbug-']").each(function(index){
            $(this).css('display', 'none');
        })
        
    }
}

/**
 * Get color associated to a state
 * @param {number} state 
 */
function getPinColor(state) {
    var patientColor = ''
    if(state == 1) {
        patientColor = '#4EC04E';
    } else if(state == 2) {
        patientColor = '#9FB94A';
    } else if(state == 3) {
        patientColor = '#FFC84A';
    } else if(state == 4) {
        patientColor = '#F48847';
    } else if(state == 5) {
        patientColor = '#EB4841';
    }

    return patientColor;
}

function startJavascriptMap(endpoint, attachDevicesListeners, attachPatientsListeners, attachGroupsEventListeners, angularScope, token) {
    $.ajaxSetup({
        headers:{
           'token': token
        }
     });
    config = {
        endpoint
    }


    // helper functions
    // from https://davidwalsh.name/vendor-prefix
    var prefix = (function () {
        var styles = window.getComputedStyle(document.documentElement, ''),
            pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1],
            dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];
        
        return {
            dom: dom,
            lowercase: pre,
            css: '-' + pre + '-',
            js: pre[0].toUpperCase() + pre.substr(1)
        };
    })();

    // vars & stuff
    var support = {transitions : Modernizr.csstransitions},
        transEndEventNames = {'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd', 'msTransition': 'MSTransitionEnd', 'transition': 'transitionend'},
        transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
        onEndTransition = function(el, callback, propTest) {
            var onEndCallbackFn = function( ev ) {
                if( support.transitions ) {
                    if( ev.target != this || propTest && ev.propertyName !== propTest && ev.propertyName !== prefix.css + propTest ) return;
                    this.removeEventListener( transEndEventName, onEndCallbackFn );
                }
                if( callback && typeof callback === 'function' ) { callback.call(this); }
            };
            if( support.transitions ) {
                el.addEventListener( transEndEventName, onEndCallbackFn );
            }
            else {
                onEndCallbackFn();
            }
        }
    ,
    // Global variables declarations (will be used in document.ready())
    mall,mallLevelsEl,mallLevels,mallLevelsTotal,mallSurroundings,selectedLevel,mallNav,allLevelsCtrl,levelUpCtrl,levelDownCtrl,pins,contentEl,isNavigating,isExpanded,spaceref,spacesList,openSearchCtrl,containerEl,closeSearchCtrl

    

    /**
     * Floors and PINS Initialization
     */
        
        var moduleId = "#module-map";
        var lastPatients = [];
        // sending a GET request to backend to retrive floors
        
        $.get(config['endpoint'] + "/floors").then(function(response) {
            
            hiddenButtonNavigate();
            showLevelbutton();
            // draw floors
            /*
            response.data.forEach(function(floor, index){
                var floora = angularScope.floorService.getFloors()[0];
                floora.image = floora.image.replace('svg', 'png');
                alert(floora.image);
                $(moduleId + " .levels").append('\
                <div #level-123 class="level level--'+ floor.id +'" aria-label="Level '+ floor.id +'" style="width:800px; height:436px; top:200px;">\
                    <svg class="map map--'+ floor.id +'" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">\
                        <title>Map Level '+ floor.id +'</title> \
                        <image x="0" y="0" width="100%" href="" id="floor' + floor.id + '" height="100%" href="/assets/map-3d/img/map.png"> \
                            <title>Image from db</title> \
                        </image> \
                    </svg> \
                    <div class="level__pins"></div>\
                </div>');
                $(moduleId + ' #button-levels').append('<button class="btn btn-primary mx-1 custom-select-level" data-level = "'+ floor.id +'" ><span data-i18n="Level">Level</span> '+ floor.id +'</button>');
            });
            */

           var floors = angularScope.floorService.getFloors(true);
           let css=[{top:-100,left:280},{top:0,left:200},{top:200,left:0}];
           for(let f=0; f < floors.length; f++) {
               let floor = floors[f];
               $(moduleId + " .levels").append('\
               <div #level-123 class="level level--'+ floor.id +'" aria-label="Level '+ floor.id +'" style="width:1200px; height:654px; top:'+css[f].top+'px;left:'+css[f].left+'px;">\
                   <svg class="map map--'+ floor.id +'" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">\
                       <title>Map Level '+ floor.id +'</title> \
                       <image x="0" y="0" width="100%" href="'+ floor.image+'" id="floor' + floor.id + '" height="100%" href=""> \
                           <title>Image from db</title> \
                       </image> \
                   </svg> \
                   <div class="level__pins"></div>\
               </div>');
               $(moduleId + ' #button-levels').append('<button class="btn btn-primary mx-1 custom-select-level" data-level = "'+ floor.id +'" ><span data-i18n="Level">Level</span> '+ floor.id +'</button>');
           }

            // the mall element
            mall = document.querySelector('.mall'),
            // mall´s levels wrapper
            mallLevelsEl = mall.querySelector('.levels'),
            // mall´s levels
            mallLevels = [].slice.call(mallLevelsEl.querySelectorAll('.level')),
            // total levels
            mallLevelsTotal = mallLevels.length,
            // surroundings elems
            mallSurroundings = [].slice.call(mall.querySelectorAll('.surroundings')),
            // selected level position
            selectedLevel,
            
            // check if currently animating/navigating
            isNavigating,
            // check if all levels are shown or if one level is shown (expanded)
            isExpanded,
            
            // reference to the current shows space (name set in the data-name attr of both the listed spaces and the pins on the map)
            spaceref,
            
            // smaller screens:
            // open search ctrl
            openSearchCtrl = document.querySelector('button.open-search'),
            // main container
            containerEl = document.querySelector('.container'),
            
        
            // Init Events
            mallLevels.forEach(function(level, pos) {
                level.addEventListener('click', function() {
                    // shows this level
                    showLevel(pos+1);   //!!!---FIXME: sostituire pos+1 con level.id
                });
            });

            // getting smartbugs
            $.get(config['endpoint'] + "/locations/smartbugs").then(function(response) {
                // draw smartbugs
                response.data.forEach(function(smartbug){
                    let color='';
                    let nameSB = '';
                    if (smartbug.name==null || smartbug.name == undefined || smartbug.name == ''){
                        nameSB = smartbug.sb_id.substr(0,3)+smartbug.sb_id.substr(12)
                    } else {
                        nameSB = smartbug.name;
                    }
                    if(smartbug.live) {
                        color='blue';
                        cl = '';
                    } else {
                        color='red';
                        cl = 'blink_me'
                    }
                        $(".levels .level--"+smartbug.floor_id+" .level__pins").append('\
                        <span class="pin smartbug-pin smartbug-'+smartbug.sb_id+'" data-sb-id=' + smartbug.sb_id + ' style="top: '+ (smartbug.y_position)+ '%; left: '+ (smartbug.x_position) + '%; " iddata-category="1" data-space="'+smartbug.floor_id+'.02">\
                        <label class="pin-label">'+nameSB+'</label>\
                            <span class="pin__icon '+cl+'" style="color:'+color+'">\
                                <i class="nav-icon fas fa-circle smartbug-pin__icon" style="color:'+color+'"></i>\
                            </span>\
                        </span>'
                        );
                })
                // ANGULAR BRIDGE
                // THIS METHOD CONNECTS THIS FILE TO TYPESCRIPT PASSING "THIS" AS "ANGULARSCOPE"
                attachDevicesListeners(angularScope);
            });

            smartbugLastInterval = setInterval(function(){
                // getting smartbugs
                $.get(config['endpoint'] + "/locations/smartbugs").then(function(response) {
                    // draw smartbugs

                    response.data.forEach(function(smartbug){
                        $('.smartbug-'+smartbug.sb_id).remove();
                        let color='';let nameSB = '';
                        if (smartbug.name==null || smartbug.name == undefined || smartbug.name == ''){
                            nameSB = smartbug.sb_id.substr(0,3)+smartbug.sb_id.substr(12)
                        } else {
                            nameSB = smartbug.name;
                        }

                        if(smartbug.live) {
                            color='blue';
                            cl = '';
                        } else {
                            color='red';
                            cl = 'blink_me'
                        }
                            $(".levels .level--"+smartbug.floor_id+" .level__pins").append('\
                            <span class="pin smartbug-pin smartbug-'+smartbug.sb_id+'" data-sb-id=' + smartbug.sb_id + ' style="top: '+ (smartbug.y_position)+ '%; left: '+ (smartbug.x_position) + '%; " iddata-category="1" data-space="'+smartbug.floor_id+'.02">\
                            <label class="pin-label">'+nameSB+'</label>\
                                <span class="pin__icon '+cl+'" style="color:'+color+'">\
                                    <i class="nav-icon fas fa-circle  smartbug-pin__icon" style="color:'+color+'"></i>\
                                </span>\
                            </span>'
                            );
                    })
                    // ANGULAR BRIDGE
                    // THIS METHOD CONNECTS THIS FILE TO TYPESCRIPT PASSING "THIS" AS "ANGULARSCOPE"
                    attachDevicesListeners(angularScope);
                });
                },10000);

            $.get(config['endpoint'] + "/locations/patients/last").then(function(response) {
                lastPatients = response.data;
                response.data.forEach(function(patient, index){
                   
                    var color = '';
                    color = getPinColor(patient.patient_id);
                    // append patient PIN to floor
                    $(".levels .level--"+patient.floor_id+" .level__pins").append('\
                    <span class="pin patient-pin transitions-patients patient-'+patient.patient_id+'" style="top: '+ (patient.y_position)+ '%; left: '+ (patient.x_position) + '%; " iddata-category="1" data-space="'+patient.floor_id+'.02" data-sb-id="' + patient.sb_id + '" data-patient="'+patient.patient_id+'"  data-episode="'+patient.episode_id+'" aria-label="'+patient.patient_name+' '+patient.patient_surname+'">\
                        <span class="pin__icon">\
                            <div style="margin-left:-30px" >'+patient.patient_name+' '+patient.patient_surname+'</div>\
                            <i class="nav-icon fas fa-user" style="color:' + color + ';" ></i>\
                        </span>\
                    </span>');


                    if($.inArray(patient.sb_id, patientPositions) === -1) {
                        patientPositions.push(patient.sb_id);
                        
                    } else {
                    
                        // If this patient's position is already in positions array, there is already some other patient there!
                        var patients_number = 2;                                    
                        if(groupPositions[patient.sb_id] !== undefined) {
                            patients_number = groupPositions[patient.sb_id].patients_number + 1
                            groupPositions[patient.sb_id].patients_number = patients_number;
                            groupPositions[patient.sb_id].patients.push(patient.patient_id);
                        } else {
                            groupPositions[patient.sb_id] = {
                                'x_position': patient.x_position,
                                'y_position': patient.y_position,
                                'floor_id': patient.floor_id,
                                'patients_number':  patients_number,
                                'patients':[]
                            }
                            $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                                groupPositions[patient.sb_id].patients.push($(this).data('patient'));
                            });
                        }
                    
                        $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                            $(this).css("display","none"); //remove();    
                        });
                       
                    }
                });

                // create group icons and hides relative patients' icons
                Object.keys(groupPositions).forEach(function(groupPositionKey){
                    $(".levels .level--"+groupPositions[groupPositionKey].floor_id+" .level__pins").append('\
                        <span class="pin transitions-patients group-pin patientsGroup" data-group-id = "' + groupPositionKey + '" style="top: '+ (groupPositions[groupPositionKey].y_position) + '%; left: '+ (groupPositions[groupPositionKey].x_position) + '%; " data-patient = "patientsGroup" iddata-category="1" data-space="'+groupPositions[groupPositionKey].floor_id+'.02" >\
                            <span class="pin__icon">\
                                <i class="nav-icon green fas fa-users fa-2x text-success"></i>\
                                '+ groupPositions[groupPositionKey].patients_number +'\
                            </span>\
                        </span>');
                });

                // pins
                pins = [].slice.call(mallLevelsEl.querySelectorAll('.pin'))

                // ANGULAR BRIDGES. THOSE METHODS ARE CALLED INSIDE THE TYPESCRIPT
                // PASSING THE ANGULAR "THIS" SCOPE AS PARAMETER
                attachPatientsListeners(angularScope);
                attachGroupsEventListeners(angularScope);
                
            }).catch(e => {
                alert('expired session 1');
                window.location.replace("/pages/login");
            });

            // every 10 seconds I monitor the movements of the patients
            patientLastInterval = setInterval(function(){
                $.get(config['endpoint'] + "/locations/patients/last").then(function(response) {
                    //var patients = [];
                    // I create a check variable to check if I find the patient
                    var currentPatients = [];
                    // Array containing all the possible position keys for patients (ex. SB_IDs)
                    patientPositions = []; 
                    // Array containing all the possible position keys for patiens groups (ex. SB_IDs)
                    groupPositions = [];

                    // remove all the group pins
                    var groupPins = $(moduleId + ' .patientsGroup');
                    groupPins.remove();
                    

                    response.data.forEach(function(patient){
                        // check the position of the patients just received with the patients of the old call
                        lastPatients.forEach(function(lastPatient){
                            // if the patient_id are the same, check their position and set currentPatients = true
                            if(patient.patient_id === lastPatient.patient_id) {
                                // if the position changes then I update the position 
                                if(patient.floor_id !== lastPatient.floor_id || patient.x_position !== lastPatient.x_position || patient.y_position !== lastPatient.y_position) {
                                    var patientPin = $(moduleId + ' .patient-'+patient.patient_id);
                                    if( patient.floor_id === lastPatient.floor_id) {
                                        // if the floor is the same, we move a patient pin
                                        // css file has transition animation defined inside
                                        patientPin.css({
                                            "display": "block"
                                        });
                                        
                                        patientPin.css({
                                            "top": patient.y_position + '%', 
                                            "left": patient.x_position + '%'
                                        });
                                        
                                        // setting up the new data sb-id
                                        patientPin.data('sb-id',patient.sb_id);
                                        // both on dom and on the jquery element
                                        patientPin.attr('data-sb-id', patient.sb_id);
                                    } else {
                                        var color = ""
                                        // if the level is different, I remove the pin and create another pin with same patient_id, in the right level
                                        patientPin.remove();
                                        
                                        color = getPinColor(patient.patient_id);
                                        // Draw pin on the map
                                        $(".levels .level--"+patient.floor_id+" .level__pins").append('\
                                        <span class="pin patient-pin transitions-patients patient-'+patient.patient_id+'" style="top: '+ (patient.y_position)+ '%; left: '+ (patient.x_position) + '%; " iddata-category="1" data-space="'+patient.floor_id+'.02" data-sb-id="' + patient.sb_id + '" data-patient="'+patient.patient_id+'" data-episode="'+patient.episode_id+'" aria-label="'+patient.patient_name+' '+patient.patient_surname+'">\
                                            <span class="pin__icon">\
                                            <div style="margin-left:-30px" >'+patient.patient_name+' '+patient.patient_surname+'</div>\
                                                <i class="nav-icon fas fa-user" style="color:' + color + ';" ></i>\
                                            </span>\
                                        </span>');
                                    }
                                }
                                
                                // Add this patient's id to currentPatients array
                                // currentPatients contains the patients actually drawed in the map
                                currentPatients.push(patient.patient_id);

                                    // Add this patient's position to patientPositions array
                                    // patientPositions contains an array of smartbugs_id.
                                    if($.inArray(patient.sb_id, patientPositions) === -1) {
                                        patientPositions.push(patient.sb_id);
                                    } else {
                                        // If this patient's position is already in positions array, there is already some other patient there!
                                        var patients_number = 2;                         
                                        // if the group has already set from the last iteration           
                                        if(groupPositions[patient.sb_id] !== undefined) {
                                            // then i only set new parameters
                                            patients_number = groupPositions[patient.sb_id].patients_number + 1
                                            groupPositions[patient.sb_id].patients_number = patients_number;
                                            groupPositions[patient.sb_id].patients.push(patient.patient_id);
                                        } else {
                                            // if the group hasn't been already set
                                            // initialize 
                                            groupPositions[patient.sb_id] = {
                                                'x_position': patient.x_position,
                                                'y_position': patient.y_position,
                                                'floor_id': patient.floor_id,
                                                'patients_number':  patients_number,
                                                'patients':[]
                                            }
                                            $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                                                // pushing the patient id into 'patients' array of the group
                                                groupPositions[patient.sb_id].patients.push($(this).data('patient'));
                                            });
                                        }
                                    
                                        $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                                            var element = this;
                                            // TODO: Fix timeoutMilliseconds for those who are already in group in last request
                                            setTimeout(function(){
                                                $(element).css("display","none");
                                            }, 0); // TODO: 0 seconds now
                                            
                                        });
                                    }
                            } // END IF SAME PATIENT
                            

                        });

                        // create new patient       
                        if($.inArray(patient.patient_id, currentPatients) === -1){
                           
                            // if not found I append a new pin on the pins
                            // append patient PIN to floor
                            var color = '';
                            color = getPinColor(patient.patient_id);
                            $(".levels .level--"+patient.floor_id+" .level__pins").append('\
                            <span class="pin patient-pin transitions-patients patient-'+patient.patient_id+'" style="top: '+ (patient.y_position) + '%; left: '+ (patient.x_position) + '%; "  iddata-category="1" data-space="'+patient.floor_id+'.02" data-sb-id="' + patient.sb_id + '" data-patient="'+patient.patient_id+'" data-episode="'+patient.episode_id+'" aria-label="'+patient.patient_name+' '+patient.patient_surname+'">\
                                <span class="pin__icon">\
                                <div style="margin-left:-30px" >'+patient.patient_name+' '+patient.patient_surname+'</div>\
                                    <i class="nav-icon red fas fa-user" style="color:' + color + ';"></i>\
                                </span>\
                            </span>');
                            // Add this patient's position to patientPositions array
                            // patientPositions contains an array of smartbugs_id.
                            if($.inArray(patient.sb_id, patientPositions) === -1) {
                                patientPositions.push(patient.sb_id);
                            } else {
                                // If this patient's position is already in positions array, there is already some other patient there!
                                var patients_number = 2;                         
                                // if the group has already set from the last iteration           
                                if(groupPositions[patient.sb_id] !== undefined) {
                                    // then i only set new parameters
                                    patients_number = groupPositions[patient.sb_id].patients_number + 1
                                    groupPositions[patient.sb_id].patients_number = patients_number;
                                    groupPositions[patient.sb_id].patients.push(patient.patient_id);
                                } else {
                                    // if the group hasn't been already set
                                    // initialize 
                                    groupPositions[patient.sb_id] = {
                                        'x_position': patient.x_position,
                                        'y_position': patient.y_position,
                                        'floor_id': patient.floor_id,
                                        'patients_number':  patients_number,
                                        'patients':[]
                                    }
                                    $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                                        groupPositions[patient.sb_id].patients.push($(this).data('patient'));
                                    });
                                    // .
                                    
                                }
                                
                                // hide pins in group
                                $(".patient-pin[data-sb-id='" + patient.sb_id + "']").each(function() {
                                    $(this).css("display","none"); //remove();
                                });
                            
                            }
                            
                            currentPatients.push(patient.patient_id);
                        }
                    })
                    // Check if any patients previously shown (in lastPatients) are now no more present 
                    lastPatients.forEach(function(patient) {
                        if($.inArray(patient.patient_id, currentPatients) === -1){
                            $(moduleId + ' .patient-'+patient.patient_id).css({"top":1000 + '%', "left": 50 + '%'});
                            setTimeout(function(){
                                $(moduleId + ' .patient-'+patient.patient_id).remove();                
                            },1300);
                            
                        }
                    });
                    lastPatients=response.data;

                    // create group icons and hides relative patients' icons
                    Object.keys(groupPositions).forEach(function(groupPositionKey){
                        $(".levels .level--"+groupPositions[groupPositionKey].floor_id+" .level__pins").append('\
                            <span class="pin transitions-patients group-pin patientsGroup" data-group-id = "' + groupPositionKey + '" style="top: '+ (groupPositions[groupPositionKey].y_position) + '%; left: '+ (groupPositions[groupPositionKey].x_position) + '%; " data-patient = "patientsGroup" iddata-category="1" data-space="'+groupPositions[groupPositionKey].floor_id+'.02" >\
                                <span class="pin__icon">\
                                    <i class="nav-icon green fas fa-users fa-2x text-success"></i>\
                                    '+ groupPositions[groupPositionKey].patients_number +'\
                                </span>\
                            </span>');
                    });

                    // pins
                    pins = [].slice.call(mallLevelsEl.querySelectorAll('.pin'))

                    // ANGULAR BRIDGES. THOSE METHODS ARE CALLED INSIDE THE TYPESCRIPT
                    // PASSING THE ANGULAR "THIS" SCOPE AS PARAMETER
                    attachPatientsListeners(angularScope);
                    attachGroupsEventListeners(angularScope);
                }).catch(e => {
                    alert('expired session 2');
                    window.location.replace("/pages/login");
                });;
            

            }, 5000);

        }).then(function() {
            $(moduleId +' .custom-select-level').on('click',function() {
                showLevel($(this).data('level'));
            });
            setOpacityLevel();
            showPins();
            
        }).catch(e => {
            console.log(e);
            alert('expired session 3');
            window.location.replace("/pages/login");
        });


        $(moduleId +' #all-levels').on('click',function(){ showAllLevels() });
        $(moduleId +' #up-level').on('click', function(){  showLevel(navigate('Down')) });
        $(moduleId +' #down-level').on('click',function(){ showLevel(navigate('Up')) });
        


    /**
     * Opens a level. The current level moves to the center while the other ones move away.
     */
    function showLevel(level) {
        if( isExpanded ) {
            return false;
        }
        removeOpacityLevel();
        hiddenLevelbutton();
        // update selected level val
        selectedLevel = level;

        
        classie.add(mallLevelsEl, 'levels--selected-' + selectedLevel);
        // the level element
        var levelEl = mallLevels[selectedLevel - 1];
        classie.add(levelEl, 'level--current');
        onEndTransition(levelEl, function() {
            classie.add(mallLevelsEl, 'levels--open');
            // aggiunto per enel non mostra i livelli che creano interferenza
            for(var i=0; i < mallLevels.length; i++) {
                if(i != selectedLevel - 1){
                    classie.add(mallLevels[i], 'levels--display--none');
                } 
            }

            // show level pins
            showPins();

            isExpanded = true;
            showButtonNavigate();
        }, 'transform');
        
        // hide surroundings element
        hideSurroundings();
        
        
    }

    /**
     * Shows all Mall´s levels
     */
    function showAllLevels() {
        if( isNavigating || !isExpanded ) {
            return false;
        }
        isExpanded = false;

        classie.remove(mallLevels[selectedLevel - 1], 'level--current');
        classie.remove(mallLevelsEl, 'levels--selected-' + selectedLevel);
        classie.remove(mallLevelsEl, 'levels--open');
        for(var i=0; i < mallLevels.length; i++) {
                classie.remove(mallLevels[i], 'levels--display--none');
        }
        // hide level pins
        //removePins();

        // shows surrounding element
        setOpacityLevel();
        showSurroundings();
        showLevelbutton();
        hiddenButtonNavigate();

    }


    /**
     * Shows the level´s pins
     */
    function showPins(levelEl) {
    //  var levelEl = levelEl || mallLevels[selectedLevel - 1];
    //  classie.add(levelEl.querySelector('.level__pins'), 'level__pins--active');
    $('.level__pins').addClass('level__pins--active');
    }

    /**
     * Removes the level´s pins
     */
    function removePins(levelEl) {
        var levelEl = levelEl || mallLevels[selectedLevel - 1];
        classie.remove(levelEl.querySelector('.level__pins'), 'level__pins--active');
    }



    /**
     * Show the surroundings level
     */
    function showSurroundings() {
        mallSurroundings.forEach(function(el) {
            classie.remove(el, 'surroundings--hidden');
        });
    }

    /**
     * Hide the surroundings level
     */
    function hideSurroundings() {
        mallSurroundings.forEach(function(el) {
            classie.add(el, 'surroundings--hidden');
        });
    }

    /**
     * Navigate through the mall´s levels
     */
    function navigate(direction) {
        if( isNavigating || !isExpanded ) {
            return false;
        }
        isNavigating = true;

        var prevSelectedLevel = selectedLevel;

        // current level
        var currentLevel = mallLevels[prevSelectedLevel-1];

        if( direction === 'Up' && prevSelectedLevel > 1 ) {
            --selectedLevel;
        }
        else if( direction === 'Down' && prevSelectedLevel < mallLevelsTotal ) {
            ++selectedLevel;
        }
        else {
            isNavigating = false;	
            return false;
        }

        
        // transition direction class
        classie.add(currentLevel, 'level--moveOut' + direction);
        // next level element
        var nextLevel = mallLevels[selectedLevel-1]
        // ..becomes the current one
        classie.add(nextLevel, 'level--current');

        // when the transition ends..
        onEndTransition(currentLevel, function() {
            classie.remove(currentLevel, 'level--moveOut' + direction);
            // solves rendering bug for the SVG opacity-fill property
            setTimeout(function() {classie.remove(currentLevel, 'level--current');}, 60);

            classie.remove(mallLevelsEl, 'levels--selected-' + prevSelectedLevel);
            classie.add(mallLevelsEl, 'levels--selected-' + selectedLevel);

            // show the current level´s pins
            showPins();

            isNavigating = false;
        });

        // filter the spaces for this level
        //showLevelSpaces();

        // hide the previous level´s pins
        //removePins(currentLevel);
    }

    function hiddenButtonNavigate() {
        $('#all-levels').addClass('d-none');
        $('#up-level').addClass('d-none');
        $('#down-level').addClass('d-none');
    }

    function showButtonNavigate() {
        $('#all-levels').removeClass('d-none');
        $('#up-level').removeClass('d-none');
        $('#down-level').removeClass('d-none');
    }
    function showLevelbutton() {
        $('#button-levels').removeClass('d-none');
    }
    function hiddenLevelbutton() {
        $('#button-levels').addClass('d-none');
    }
    function setOpacityLevel(){
        $('.map').addClass('opacity-level');
    }
    function removeOpacityLevel(){
        $('.map').removeClass('opacity-level');
    }

}